import React, { useCallback, useMemo } from 'react';
import { TabProps } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '@features/group-selection/ui/group-selection.scss';
import GroupSelectionSetsList from '@features/group-selection/ui/GroupSelectionSetsList';
import { GroupSelectionProvider } from '@context/groupSelectionContext';
import { GroupSelectionOutletContext } from '@features/group-selection/model/types';
import { useNavigatePreserveSearch } from '@hooks/useNavigatePreserveSearch';
import IconTabs, { LeftTabs } from '@features/left-panel-tabs/IconTabs';

const GroupSelection = ({
    entityName,
    sourceEntityName,
    groupUpdateTaskArgument,
    showDeleteBtn = true,
    showTabs = false,
}: GroupSelectionOutletContext) => {
    const { t } = useTranslation();
    const navigate = useNavigatePreserveSearch();
    const { pathname } = useLocation();
    const isOperationsTab = /\/groupselection\/operations\/?$/.test(pathname);

    const tabs: TabProps<any, LeftTabs>[] = useMemo(
        () => [
            {
                path: '',
                label: 'Override',
                url: './',
                testId: 'groupSelectionOverrideTab',
            },
            {
                path: 'operations',
                label: 'Operations',
                url: './operations',
                testId: 'groupSelectionOperationsTab',
            },
        ],
        []
    );

    const onSetSave = useCallback(
        (id: string) => {
            navigate(`./${id}`);
        },
        [navigate]
    );

    return (
        <GroupSelectionProvider entityName={entityName} sourceEntityName={sourceEntityName}>
            <div className="group-selection">
                {showTabs && <IconTabs tabs={tabs} />}
                {showTabs && isOperationsTab ? (
                    <Outlet
                        context={{
                            entityName,
                            sourceEntityName,
                            groupUpdateTaskArgument,
                            showDeleteBtn,
                        }}
                    />
                ) : (
                    <>
                        <section className="section">
                            <p className="description">
                                {t('road-network.group-selection-description')}
                            </p>
                            <Outlet
                                context={{
                                    entityName,
                                    sourceEntityName,
                                    groupUpdateTaskArgument,
                                    showDeleteBtn,
                                }}
                            />
                        </section>
                        <section className="section">
                            <GroupSelectionSetsList onSave={onSetSave} />
                        </section>
                    </>
                )}
            </div>
        </GroupSelectionProvider>
    );
};

export default GroupSelection;
